<template>
	<div class="full-screen-login">
		<img :src="bgImg" class="background-image" />
		<div class="login-icon-box">
			<van-image width="300" height="77" :src="iconJpg" class="icon-box" />
		</div>
		<div class="login-title-box" >
			<span>{{systemName}}</span>
		</div>
		<div class="login-title-box" >
			<span style="font-size: 15px;">一项多中心、回顾性真实世界研究</span>
		</div>

		<div class="login-mode-box" v-if="!loginMode" style="display: none;">
			<van-button type="info" block @click="CheckOpenId">系统用户登录</van-button>
			<van-button type="primary" block @click="CheckPatOpenId">患者用户登录</van-button>
		</div>

		<div class="login-box" v-if="loginMode=='system'">
			<van-form @submit="onSubmit">
				<van-cell-group>
					<van-field v-model="userphone" label="用户名" placeholder="用户名"
						:rules="[{ required: true, message: ' ' }]">
					</van-field>

					<van-field v-model="password" label="密码" type="password" placeholder="密码"
						:rules="[{ required: true, message: ' ' }]"></van-field>
					<van-row>
						<van-col span="16">
							<van-field v-model="code" label="验证码" placeholder="验证码"
								:rules="[{ required: true, message: ' ' }]">
							</van-field>
						</van-col>
						<van-col span="8" class="login-image-col">
							<img :src="codeImg" @click="GetCode" class="login-image" />
						</van-col>
					</van-row>
				</van-cell-group>

				<div style="margin: 16px">
					<van-row gutter="20" style="display: flex; justify-content: center">
						<van-col span="12">
							<van-button round block type="info" native-type="submit">
								登录
							</van-button>
						</van-col>
						<van-col span="12" v-show="false">
							<van-button round block type="primary" @click="loginMode=''">
								切换
							</van-button>
						</van-col>
					</van-row>
				</div>
			</van-form>
		</div>

		<div class="login-box" v-if="loginMode=='patient'">
			<van-form @submit="onSubmitPatient">
				<van-cell-group>
					<van-field v-model="idCard" label="身份证" placeholder="身份证"
						:rules="[{ required: true, message: ' ' }]">
					</van-field>
					<van-field v-model="userTel" label="电话" placeholder="电话"
						:rules="[{ required: true, message: ' ' }]">
					</van-field>
					<!--        <van-row>
            <van-col span="16">
              <van-field v-model="code" label="验证码" placeholder="验证码" :rules="[{ required: true, message: ' ' }]">
              </van-field>
            </van-col>
            <van-col span="8" class="login-image-col">
              <img :src="codeImg" @click="GetCode" class="login-image" />
            </van-col>
          </van-row> -->
				</van-cell-group>

				<div style="margin: 16px">
					<van-row gutter="20" style="display: flex; justify-content: center">
						<van-col span="12">
							<van-button round block type="info" native-type="submit">
								登录
							</van-button>
						</van-col>
						<van-col span="12">
							<van-button round block type="primary" @click="loginMode=''">
								切换
							</van-button>
						</van-col>
					</van-row>
				</div>
			</van-form>
		</div>

		<van-overlay :show="showOverlay" class="overlay-box">
			<div class="blockBox">
				<van-loading size="50" vertical color="#1989fa">正在绑定用户...</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
	import UnicodeJs from '../script/encode/UnicodeAnsi.js'
	import base64JS from '../script/encode/base64.js'
	export default {
		name: "Login",
		data() {
			return {
				userphone: "", //用户名
				password: "", //密码
				idCard: "", // 身份证号
				userTel: "", // 电话号码
				OpenID: "", //openID
				LoginType:'',
				key: "", // 验证加密key
				code: "", // 验证码
				iconJpg: require("../assets/image/icon/zlglogo.png"), //登录页商法Icon
				bgImg: require("../assets/image/bg.jpg"), // 背景图
				codeImg: "", // 验证码图片记录变量
				//验证OpenID接口-系统用户
				urlCheckOpenID: this.$utils.Url.system + "/api/APIOAuth/CheckOpenId",
				//验证OpenID接口-病理用户
				urlCheckPatOpenID: this.$utils.Url.s400 + "/api/S400Bq001/CheckLoginByOpenID",
				urlCheckLogin: this.$utils.Url.system + "/api/APIOAuth/CheckLogin", //登录接口
				urlPatientLogin: this.$utils.Url.s400 + "/api/S400Bq001/CheckLogin", //患者登录接口
				showOverlay: false, //遮罩层参数
				systemName: "", //系统名称
				loginMode: "", // 系统登录模式
			};
		},

		methods: {
			//登录操作
			onSubmit() {
				let that = this;
				let passwordNew = base64JS.encode64(UnicodeJs.strUnicode2Ansi(that.password));
				console.log(passwordNew)
				let params = {
					username: that.userphone,
					password: that.password,
					key: that.key,
					value: that.code,
					openId: that.OpenID == undefined ? '' : that.OpenID,
				};
				//绑定用户信息
				that.$utils.HttpPost(that.urlCheckLogin, params, function(data) {
					//获得用户对象
					that.setUserInfo(data)
				});
			},
			// 患者登录
			onSubmitPatient() {
				let that = this
				// 电话号码加密
				let passwordNew = base64JS.encode64(UnicodeJs.strUnicode2Ansi(that.userTel));
				console.log(passwordNew)
				let params = {
					username: that.idCard,
					password: that.userTel,
					// key: that.key,
					// value: that.code,
					openId: that.OpenID == undefined ? '' : that.OpenID,
				};

				//绑定用户信息
				that.$utils.HttpPost(that.urlPatientLogin, params, function(data) {
					that.setPatientInfo(data)
				});

				console.log(params);
			},
			//获得验证码
			GetCode() {
				var that = this;
				//生成随机数
				this.key = this.$utils.Guid();
				//获得验证码
				this.$http.get(this.$utils.Url.system + "/api/APIOAuth/GetCode?key=" + this.key, {
						responseType: "arraybuffer",
					})
					.then((res) => {
						// 转化获得的base64数据
						that.codeImg = "data:image/png;base64," + btoa(
							new Uint8Array(res.data).reduce(
								(data, byte) => data + String.fromCharCode(byte),
								""
							)
						);
						// console.log(res);
					})
					.catch((err) => {
						console.log(err);
						// that.$dialog({
						//   message: "操作失败",
						// });
					});
			},
			// 成功验证系统用户后，进行信息保存和设置
			setUserInfo(data) {
				let that = this
				// that.$utils.CopyKeyInfo(data.data,data.data)
				console.log(data)
				//获得用户对象
				let userInfoObj = data.data;
				//新增设置vuex,将当前用户写入到全局变量中
				for (let key in userInfoObj) {
					let keyUp = that.$utils.toLowerCaseFirst(key)
					userInfoObj[keyUp] = userInfoObj[key]
				}

				that.$store.commit("setUserModel", userInfoObj)
				//设置Token
				let token = data.token;
				sessionStorage.setItem("Token", token);
				that.$http.defaults.headers.common["Token"] = token;
				//跳转到首页
				that.$router.push({
					name: "Home",
				});
			},
			// 成功验证患者后，进行信息保存和设置
			setPatientInfo(data) {
				let that = this
				// //获得用户对象
				let patientModel = data.data;
				// //新增设置vuex,将当前用户写入到全局变量中
				that.$store.commit("setPatientModel", patientModel)
				// console.log(patientModel);
				// 跳转到患者主页
				that.$router.push({
					name: "s400PatientSelfDetail",
					params: {
						patientCard: patientModel.Bq001_018,
						id: patientModel.id
					},
				})
			},
			//验证OpenID-系统用户
			CheckOpenId: function() {
				let that = this
				if (that.OpenID) {
					let params = {
						openId: that.OpenID,
					};
					//绑定用户信息
					that.$utils.HttpPost(that.urlCheckOpenID, params, function(data) {
						that.setUserInfo(data)
					}, function() {
						// 无关联用户，进入系统登录页
						that.loginMode = 'system'
					}, null, null, null);
				}
			},
			//验证OpenID-患者
			CheckPatOpenId: function() {
				let that = this
				if (that.OpenID == undefined) {
					that.loginMode = 'patient'
					return
				}
				if (that.OpenID) {
					let params = {
						openId: that.OpenID,
					};
					//绑定用户信息
					that.$utils.HttpPost(that.urlCheckPatOpenID, params, function(data) {
						that.setPatientInfo(data)
					}, function() {
						// 无关联用户，进入系统登录页
						that.loginMode = 'patient'
					}, null, null, null);
				}
			},
		},
		mounted() {
			this.systemName = this.$utils.SystemName
			this.OpenID =this.$route.params.OpenID //sessionStorage.getItem("OpenID");
			this.LoginType = this.$route.params.LoginType
			if(this.LoginType == '1'){
				this.loginMode = 'patient'	
			}else{
				this.loginMode = 'system'
			}
			
			// if (this.LoginType == '1') {
			// 	//患者
			// 	this.CheckPatOpenId()
			// }
			// else if (this.LoginType == '2') {
			// 	//医生
			// 	this.CheckOpenId()
			// }			
			this.GetCode();
		},
	};
</script>
<style scoped>
::v-deep #app {
		background-color: none;
	}

	.login-image-col {
		display: flex;
		align-items: center;
		padding: 10px 16px;
	}

	.login-image {
		width: 95%;
		height: 100%;
		max-width: 100px;
		max-height: 35px;
	}

	.forget-password-box {
		padding-top: 10px;
		text-align: center;
	}

	.forget-password-a {
		color: #909399;
	}

	/* ******************登录页面样式（开始）************************* */
	.full-screen {
		height: 100%;
		/* background-color: #fff; */
		padding-left: 10px;
		padding-right: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
	}

	.full-screen-login {
		height: 100%;
	}

	.background-image {
		width: 1520px;
		height: 100%;
		opacity: 0.3;
		position: fixed;
		top: 0;
		left: -600px;
		z-index: -1;
	}

	.background-image-right {
		width: 1520px;
		height: 100%;
		opacity: 0.3;
		position: fixed;
		top: 0;
		left: -600px;
		z-index: -1;
	}

	.icon-box {
		width: 128px;
		height: 128px;
	}

	.login-icon-box {
		padding-top: 5rem;
		text-align: center;
	}

	.login-title-box {
		margin-top: 2rem;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		color: #898ebb;
	}

	.login-mode-box {
		width: 100%;
		position: fixed;
		bottom: 40%;
		padding-left: 50px;
		padding-right: 50px;
		box-sizing: border-box;
	}

	.login-mode-box /deep/.van-button {
		margin-bottom: 20px;
	}

	.login-box {
		width: 100%;
		position: fixed;
		bottom: 10px;
		padding-left: 10px;
		padding-right: 10px;
		box-sizing: border-box;
	}

	.register-box {
		width: 100%;
		position: fixed;
		bottom: 30px;
	}

	/* ******************登录页面样式（结束）************************* */
	.code-image-box {}
</style>
